import {
    BASIC_COMPOSITION,
    BASIC_COMPOSITION_TYPE,
    CATEGORY_TYPE,
    ETK_STANDARD,
    IS_ADDITIONAL_TYPE,
    IS_NEXT_CARD,
    IS_WORKFLOW_TYPE,
    ITEM_TYPE,
    NO_ThANKS_CARD,
    OFFER_FIRST_TYPE,
    TCPOS,
} from "@constants";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";
import { useSnapshot } from "valtio";

import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { areEqual } from "react-window";
import { Card } from "reactstrap";

import { store } from "@store";

import AdditionalSale from "@components/OrderTaking/Components/Dialogs/AdditionalSale";
import AlertDialog from "@components/OrderTaking/Components/Dialogs/AlertDialog/AlertDialog";
import NutritionalInformationDialog from "@components/OrderTaking/Components/Dialogs/NutritionalInformation/NutritionalInformationDialog";
import ProductSizeDialog from "@components/OrderTaking/Components/Dialogs/ProductSizeDialog";
import { RemoveProductConfirmation } from "@components/OrderTaking/Components/Dialogs/RemoveProductConfirmation";
import {
    addHiddenBasicComp,
    getProductTitle,
    removeItemCommandTcPos,
    useToggle,
} from "@components/OrderTaking/Helpers";
import {
    addToOrder,
    addToOrderworkflow,
    addWorkFlowItemShopCart,
    ClearWorkflowItem,
    intializeItemSelectedBasicComp,
    minusNbrChoiceOfCurrentStep,
    removeFromOrder,
    removeFromSelectedAdditionalItems,
    removeFromWorkFlowItemShopCart,
    selectedAdditionalItems,
    SelectProduct,
    setActiveCategoryParent,
    setActiveSizeDialogProductId,
    setAdditionalItems,
    setIsCommentKeyboardActive,
    setIsModification,
    setiuudWorkflow,
    setMenuFormulaSaleData,
    setShowToast,
    setWorkflowData,
} from "@components/OrderTaking/Store/feature";

import { kioskStore } from "@pages/Kiosk/store";

import { NoThanks } from "../Cart";
import {
    animatePicture,
    animatePicturePrm,
    animatePictureWithOutShopcart,
} from "./animation";
import { OutOfStock } from "./component";
import ComponentRender from "./ComponentRender";
import {
    getItemQuantityInStep,
    getProductType,
    productHaveOneOption,
    skipStep,
} from "./helpers";
import {
    addNbrOfChoiceStep,
    canAddItemToShopCard,
    checkWorkflow,
    getAdditionalSaleItems,
    getItemPrice,
    haveAllergens,
} from "./hooks";
import "./index.css";

export default function CardProduct({
    product,
    currentWorkflow,
    orderItems,
    workflowData,
    orderWorkflowItemSlice,
}) {
    const dispatch = useDispatch();
    let listItemsToBeDeleted = [];

    const [selectedBasicComposition, setSelectedBasicComposition] =
        React.useState([]);

    const [
        isRemoveProductConfirmationDialogOpened,
        setIsRemoveProductConfirmationDialogOpened,
    ] = React.useState(false);
    const [
        isAllergenConfirmationDialogOpened,
        setIsAllergenConfirmationDialogOpened,
    ] = useToggle();

    const [
        isNutritionalInformationDialogOpen,
        setIsNutritionalInformationDialogOpen,
    ] = useToggle();

    const [isAdditionalSaleOpen, SetIsAdditionalSaleOpen] =
        React.useState(false);
    const [isProductSizeDialogOpen, setIsProductSizeDialogOpen] =
        React.useState(false);

    const { posEditor } = useSnapshot(store);
    const { isPrm, selectedSaleModeId } = useSnapshot(kioskStore);

    const { globalcard, nestedCategories, cardType, additionalSale } =
        useSelector((state) => state.orderSlice, shallowEqual);
    const {
        isShopCartDetailsActive,
        isBorderCardProductActive,
        isCommentProductActive,
    } = useSelector((state) => state.settingSlice.productSetting, shallowEqual);

    const isSizeDialogOpen = useSelector(
        (state) => state.ProductSlice.activeSizeDialogProductId === product.iuud
    );

    const isAllergenIconActive = haveAllergens(product);

    const productType = getProductType(product, currentWorkflow);

    const itemPrice = getItemPrice(
        currentWorkflow,
        product,
        selectedSaleModeId,
        orderWorkflowItemSlice?.item,
        cardType
    );
    const isHaveOneOption = productHaveOneOption(product);

    let initialItemOrder =
        product.type === ITEM_TYPE
            ? {
                  iuud: product.iuud,
                  title: product.title,
                  isReward: false,
                  isPromo: false,
                  haveComment: product?.haveComment,
                  comment: "",
                  isAdditionnalProduct: product.isAdditionnalProduct || false,
                  name:
                      product?.name?.content !== undefined
                          ? product.name.content
                          : product.title,
                  designation: product.title,
                  displayTitle: getProductTitle(product?.name),
                  quantity: 1,
                  price:
                      product.offer.isEnabled &&
                      product.offer.type === OFFER_FIRST_TYPE
                          ? 0
                          : itemPrice.price,
                  initialPrice:
                      product.offer.isEnabled &&
                      product.offer.type === OFFER_FIRST_TYPE
                          ? 0
                          : itemPrice.price,
                  isOfferLight: false,
                  suspendSale: product.suspSale,
                  specialPrice: product.specialPrice,
                  priceOfItemInStep: product.priceStep,
                  urlImage: product.image,
                  modifier: product.modifier,
                  reference: product.ref,
                  categoryParent: product.parent,
                  categoryVisibility: product.parent
                      ? globalcard.categories[product.parent]?.KioskVisibility
                      : {},
                  categoryTitle: product.categoryTitle,
                  subcategoryTitle: product.subcategoryTitle,
                  tva: product.price?.saleModeVatRates[selectedSaleModeId]
                      ? product.price?.saleModeVatRates[selectedSaleModeId]
                      : 0,
                  iuudworkflow: "",
                  isInformationModeActivated:
                      globalcard.categories[
                          nestedCategories[nestedCategories.length - 1]
                      ].isInfoModeActive ?? false,
                  workflow: [],
                  shopCart: {},
                  isModification: false,
                  fidelity: product.fid ? product.fid : 0,
                  totalFidelity: product.fid ? product.fid : 0,
                  selectedOptions: isHaveOneOption
                      ? [
                            getProductTitle(
                                product.optionsKiosk.Options[0].listOptions[0]
                                    .name
                            ),
                        ]
                      : [],
                  selectedOptionsUuid: isHaveOneOption
                      ? [
                            product.optionsKiosk.Options[0].iuud,
                            product.optionsKiosk.Options[0].listOptions[0].iuud,
                        ]
                      : [],
                  optionIndex: product.optionsKiosk?.Options[0]?.listOptions[0]
                      ?.optionIndex
                      ? product.optionsKiosk.Options[0].listOptions[0]
                            .optionIndex
                      : 0,
                  selectedIndexOptions: isHaveOneOption
                      ? [
                            product.optionsKiosk.Options[0].listOptions[0]
                                .optionIndex,
                        ]
                      : [],
                  date: Date.now(),
                  advancedItemPrice: product.price,
                  productVisibility: product.KioskVisibility,
                  haveWorkflow: product.haveWorkflow,
                  haveBasicComposition: product.haveBasicComposition,
                  isHiddenBasicComp: product.isHiddenBasicComp,
                  haveAdditionalSale: product.haveAdditionalSale,
                  unity: product.unity !== undefined ? product.unity : "",
                  nutriScore: product.nutriScore,
                  designBasicComposition: product.designBasicComposition,
                  disabled: false,
                  redirection: product.redirection === true ? true : false,
                  messageBasicComposition:
                      product.messageBasicComposition || [],
                  isSubProduct: false,
                  StepPriceRule: product.StepPriceRule,
                  offer: product.offer,
                  isOfferParent: product.offer.isEnabled,
                  isOfferChild: false,
                  showOptions: product.optionsKiosk?.showOptions,
                  defaultPrice: itemPrice.price,
                  isBcReq: product.isBcReq,
                  stepTitle: product.stepTitle ? product.stepTitle : "",
                  isFormulaItem: product.isFormulaItem || false,
              }
            : {
                  iuud: product.iuud,
                  name:
                      product?.name?.content !== undefined
                          ? product.name.content
                          : product.title,
                  quantity: 1,
              };

    const selectedAdditionnalItem = () => {
        return additionalSale?.selectedItems?.filter(
            (item) => item.iuud === product.iuud
        );
    };

    //! here after add item to bag we check if have additionnal sale or not
    if (
        product.iuud !== undefined &&
        additionalSale.parentId === product.iuud &&
        additionalSale?.listItems?.length > 0 &&
        product.modifier !== "" &&
        Boolean(isAdditionalSaleOpen) === false
    ) {
        SetIsAdditionalSaleOpen(true);
    }

    // here is items founded many times on order with different workflow but same itemIuud
    let ExistOrderItems = product.isAdditionnalProduct
        ? selectedAdditionnalItem()
        : orderItems?.filter(
              (orderItem) =>
                  !orderItem.isReward &&
                  !product.isFormulaItem &&
                  orderItem.iuud === product.iuud
          );
    const additionalItemsQuantityChosen = () => {
        return additionalSale?.selectedItems
            ?.filter((item) => item.iuud === product.iuud)
            .reduce((prev, cur) => {
                return prev + cur.quantity;
            }, 0);
    };

    const ItemQuantity = currentWorkflow
        ? getItemQuantityInStep(
              product,
              ExistOrderItems,
              orderWorkflowItemSlice,
              currentWorkflow,
              listItemsToBeDeleted
          )
        : product.isAdditionnalProduct
        ? additionalItemsQuantityChosen()
        : ExistOrderItems?.reduce((prev, curr) => prev + curr.quantity, 0);

    const isModifier =
        product.type === ITEM_TYPE &&
        ((!product.isRedirect &&
            (product.haveWorkflow ||
                (product.haveBasicComposition &&
                    (!product.isHiddenBasicComp ||
                        orderWorkflowItemSlice.isModification)))) ||
            (product.isRedirect && product.offer.isEnabled));

    const quantity =
        ExistOrderItems.length > 0 ||
        currentWorkflow ||
        product.isAdditionnalProduct
            ? ItemQuantity
            : 0;

    const canAddItem = canAddItemToShopCard(
        quantity,
        product,
        workflowData,
        orderWorkflowItemSlice
    );
    const maxAtteint =
        currentWorkflow &&
        currentWorkflow?.workflow[currentWorkflow.index]?.NbrOfChoices ===
            currentWorkflow?.workflow[currentWorkflow.index]?.maxNbrOfChoices &&
        currentWorkflow?.workflow[currentWorkflow.index].type !==
            BASIC_COMPOSITION_TYPE;

    const isAutoPermutation =
        (orderWorkflowItemSlice.isModification ||
            orderWorkflowItemSlice.isInternalModification) &&
        !orderWorkflowItemSlice.item.isOfferParent &&
        product.autoPermutation;

    const menuOnModification =
        orderWorkflowItemSlice.isModification === true ||
        orderWorkflowItemSlice.isInternalModification === true;

    const opacity = isAutoPermutation
        ? "1"
        : maxAtteint || !canAddItem
        ? "0.2"
        : "1";

    function handleRemoveProductFromOrder() {
        if (currentWorkflow) {
            const data = {
                [product.title]: {
                    name: product.title,
                    type: ITEM_TYPE,
                    quantity: 1,
                    image: product.image,
                    path: [...product.path],
                    price: product.price.content,
                },
            };

            let path = [];
            data[product.title].path.forEach((elm) => {
                elm?.name ? path.push(elm.name) : path.push(elm);
            });

            if (
                quantity > 1 &&
                ExistOrderItems.length > 1 &&
                (product.haveWorkflow ||
                    (product.haveBasicComposition &&
                        !product.isHiddenBasicComp))
            ) {
                handleRemoveProductConfirmation();
            } else {
                const product = listItemsToBeDeleted[0];
                dispatch(removeFromWorkFlowItemShopCart({ product, cardType }));
                dispatch(intializeItemSelectedBasicComp({ product, cardType }));
                dispatch(minusNbrChoiceOfCurrentStep());
                setSelectedBasicComposition([]);
            }
        } else {
            ExistOrderItems.length > 1 &&
            (product.modifier ||
                (product.haveBasicComposition && !product.isHiddenBasicComp))
                ? handleRemoveProductConfirmation()
                : product.isAdditionnalProduct
                ? dispatch(
                      removeFromSelectedAdditionalItems(ExistOrderItems[0])
                  )
                : TCPOS === posEditor
                ? dispatch(removeItemCommandTcPos(ExistOrderItems[0]))
                : dispatch(removeFromOrder(ExistOrderItems[0]));
            setSelectedBasicComposition([]);
        }
    }

    // ! add product to basket
    function handleAddProductToShopCart() {
        if (product.isAdditionnalProduct) {
            if (
                product.haveBasicComposition &&
                product.isHiddenBasicComp &&
                !product.haveWorkflow &&
                (selectedBasicComposition.length > 0 || product.isBcReq)
            ) {
                const shopcart = addHiddenBasicComp(
                    initialItemOrder,
                    workflowData,
                    globalcard,
                    selectedBasicComposition
                );
                initialItemOrder.shopCart = shopcart;
            }

            dispatch(
                selectedAdditionalItems({
                    ...initialItemOrder,
                    selectedBasicComposition,
                })
            );
            return;
        }

        if (
            initialItemOrder.haveBasicComposition &&
            !initialItemOrder.haveWorkflow &&
            initialItemOrder.isHiddenBasicComp &&
            (selectedBasicComposition.length > 0 || product.isBcReq)
        ) {
            const shopcart = addHiddenBasicComp(
                initialItemOrder,
                workflowData,
                globalcard,
                selectedBasicComposition
            );
            initialItemOrder.shopCart = shopcart;
        }
        if (initialItemOrder.isFormulaItem) {
            dispatch(
                setMenuFormulaSaleData({
                    isMenuFormulaSaleOpen: false,
                    menuFormulaIdsList: [],
                    formulaPrincipalItemPrice: 0,
                    initialItem: {},
                    isBeforeMenu: false,
                    isHaveOptionsToShow: false,
                    formulaMenuTitle: "",
                })
            );
        }
        dispatch(addToOrder({ ...initialItemOrder, selectedBasicComposition }));
        setSelectedBasicComposition([]);
        const clonedImage = isPrm
            ? animatePicturePrm(product.iuud)
            : isShopCartDetailsActive
            ? animatePicture(product.iuud)
            : animatePictureWithOutShopcart(product.iuud);

        let timer = setTimeout(() => {
            clonedImage?.remove();
        }, 1490);

        return () => clearTimeout(timer);
    }

    function addAdditionnalItemToOrder() {
        const additionalSale = getAdditionalSaleItems(globalcard, product);

        if (additionalSale?.listItems?.length > 0) {
            dispatch(setAdditionalItems(additionalSale));
            SetIsAdditionalSaleOpen(true);
        }
    }

    function AddWorkFlowItemShopCartData(
        copyworkflowData,
        withSpecialPrice,
        withStepPrice,
        selectedBasicComposition,
        isAddToShopCartClicked
    ) {
        let title = product.title;
        let path = [...product.path];
        dispatch(setiuudWorkflow(""));
        const currentItemPriceOptions = JSON.parse(
            localStorage.getItem("currentItemPriceOptions")
        );

        let newPrice = itemPrice.price;
        let selectedOptions = [];
        let selectedOptionsUuid = [];
        let selectedIndexOptions = [];
        if (currentItemPriceOptions?.selectedOptions?.length > 0) {
            selectedOptions = currentItemPriceOptions.selectedOptions;
            selectedOptionsUuid = currentItemPriceOptions.selectedOptionsUuid;
            selectedIndexOptions = currentItemPriceOptions.selectedIndexOptions;
            newPrice = currentItemPriceOptions.newPrice;
        }
        let newId = "";
        if (Object.keys(orderWorkflowItemSlice.item.shopCart).length > 0) {
            let objectTostep = product.path.reduce((prev, key) => {
                return prev[key.name] || {};
            }, orderWorkflowItemSlice.item.shopCart);

            if (Object.keys(objectTostep).length > 0) {
                newId = "|" + uuid();
                if (product.modifier || product.haveBasicComposition) {
                    title += newId;
                    path.pop();
                    path.push({
                        name: title,
                        iuud: product.iuud,
                        type: product.isRedirect ? CATEGORY_TYPE : ITEM_TYPE,
                    });
                } else {
                    title += newId;
                    path.pop();
                    path.push({
                        name: title,
                        iuud: product.iuud,
                        type: product.isRedirect ? CATEGORY_TYPE : ITEM_TYPE,
                    });
                }
            }
        }

        const data = {
            [title]: {
                title: product.title,
                name: product.title,
                designation: product.title,
                isReward: false,
                displayTitle: getProductTitle(product?.name),
                iuud: product.iuud,
                haveComment: product?.haveComment,
                comment: "",
                categoryParent: product.parent,
                categoryTitle: product.categoryTitle,
                subcategoryTitle: product.subcategoryTitle,
                categoryVisibility: product.parent
                    ? globalcard.categories[product.parent]?.KioskVisibility
                    : {},
                suspendSale: product.suspSale,
                reference: product.ref,
                type: ITEM_TYPE,
                quantity: 1,
                urlImage: product.image,
                path: [...path],
                initialPrice: itemPrice.price,
                price: newPrice,
                isOfferLight: false,
                specialPrice: product.specialPrice,
                priceOfItemInStep: product.priceStep,
                fidelity: product.fid ? product.fid : 0,
                modifier: product?.modifier,
                workflow: [...copyworkflowData],
                isModification: false,
                selectedOptions,
                selectedOptionsUuid,
                selectedIndexOptions,
                tva: product.price?.saleModeVatRates[selectedSaleModeId]
                    ? product.price?.saleModeVatRates[selectedSaleModeId]
                    : 0,
                withSpecialPrice,
                totalFidelity: product.fid ? product.fid : 0,
                withStepPrice,
                shopCart: {},
                date: Date.now(),
                priceType: withSpecialPrice ? 1 : withStepPrice ? 2 : 3,
                stepRank: product.stepRank,
                advancedItemPrice: product.price,
                stepTitle: product.stepTitle ? product.stepTitle : "",
                stepDisplayTitle: product.stepDisplayTitle
                    ? product.stepDisplayTitle
                    : "",
                productVisibility: product.KioskVisibility,
                haveWorkflow: product.haveWorkflow,
                haveBasicComposition: product.haveBasicComposition,
                unity: product.unity !== undefined ? product.unity : "",
                designBasicComposition: product.designBasicComposition,
                disabled: false,
                redirection: product.redirection === true ? true : false,
                autoPermutation: product.autoPermutation,
                messageBasicComposition: product.messageBasicComposition || [],
                isSubProduct: workflowData.length > 1 ? true : false,
                StepPriceRule: product.StepPriceRule,
                isPromo: false,
                offer: product.offer,
                isOfferParent: false,
                isOfferChild: product.isOfferChild,
                iuudworkflow: newId,
                isHiddenBasicComp: product.isHiddenBasicComp ?? false,
                defaultPrice: itemPrice.price,
                isBcReq: product.isBcReq,
                isFormulaItem: false,
            },
        };
        if (
            product.haveBasicComposition &&
            product.isHiddenBasicComp &&
            !product.haveWorkflow &&
            (selectedBasicComposition.length > 0 || product.isBcReq)
        ) {
            const shopcart = addHiddenBasicComp(
                data[title],
                copyworkflowData,
                globalcard,
                selectedBasicComposition
            );
            data[title].compositions = shopcart;
        }
        dispatch(
            addWorkFlowItemShopCart({
                ...data[title],
                selectedBasicComposition,
            })
        );
        if (isModifier) {
            dispatch(
                SelectProduct({
                    ...product,
                    iuudworkflow: newId,
                    selectedBasicComposition,
                    isAddToShopCartClicked,
                })
            );
        }
        if (
            isCommentProductActive === true &&
            product.haveComment &&
            workflowData[workflowData.length - 1]?.workflow[
                workflowData[workflowData.length - 1].index
            ].Items.length === 1
        ) {
            dispatch(
                setIsCommentKeyboardActive({
                    product: { ...data[title] },
                })
            );
        }

        // AdditionalSale;
        if (product.haveAdditionalSale) {
            addAdditionnalItemToOrder();
        }
    }

    function handleRemoveProductConfirmation() {
        setIsRemoveProductConfirmationDialogOpened(
            !isRemoveProductConfirmationDialogOpened
        );
    }

    const handleAddProductClick = (
        selectedBasicComposition = [],
        isAddToShopCartClicked
    ) => {
        if (product.outOfStock || product.isSuspended) {
            return;
        }
        if (
            (product?.type !== BASIC_COMPOSITION &&
                currentWorkflow !== undefined &&
                currentWorkflow?.workflow[currentWorkflow.index]
                    ?.NbrOfChoices ===
                    currentWorkflow?.workflow[currentWorkflow.index]
                        .maxNbrOfChoices &&
                !isAutoPermutation) ||
            (isAutoPermutation && quantity > 0)
        ) {
            dispatch(setShowToast({ maxProduct: 0 }));
        }
        if (opacity === "0.2" || (isAutoPermutation && quantity > 0)) {
            const elm = document.getElementsByClassName("tada-animation");

            for (let index = 0; index < 4; index++) {
                elm && elm[index]?.classList.add("tada");
            }

            let timer = setTimeout(() => {
                for (let index = 0; index < 4; index++) {
                    elm && elm[index]?.classList.remove("tada");
                }
            }, 700);
            return () => clearTimeout(timer);
        } //in case workflow step  nbr of choice = max click

        if (product.type === ITEM_TYPE) {
            const isHaveBeforeMenuFormula =
                product.menu &&
                !product.menu.isAfter &&
                product.menu.isActive &&
                product.menu.list.length > 0 &&
                !product.isStepItem &&
                !product.isFormulaItem;

            const isHaveOptionsToShow =
                (product?.optionsKiosk?.showOptions &&
                    product?.optionsKiosk?.Options[0]?.listOptions.length > 0 &&
                    currentWorkflow === undefined) ||
                (cardType === ETK_STANDARD &&
                    product?.optionsKiosk?.showOptions &&
                    product?.optionsKiosk?.Options[0]?.listOptions.length > 0 &&
                    currentWorkflow &&
                    currentWorkflow?.workflow[currentWorkflow.index]
                        ?.NbrOfChoices >=
                        currentWorkflow.workflow[currentWorkflow.index]
                            .nbrOfChoicesWithspecialPrice);

            //*  Check if item have BEFORE menu formula
            if (isHaveBeforeMenuFormula) {
                dispatch(
                    setMenuFormulaSaleData({
                        isMenuFormulaSaleOpen: true,
                        menuFormulaIdsList: product.menu.list,
                        formulaPrincipalItemPrice: itemPrice.price,
                        initialItem: {
                            ...initialItemOrder,
                            isHaveOptionsToShow,
                            selectedBasicComposition,
                            isAddToShopCartClicked,
                        },
                        isBeforeMenu: true,
                        formulaMenuTitle: product.menu.title,
                    })
                );
                return;
            }
            if (isHaveOptionsToShow) {
                setIsProductSizeDialogOpen(true);
                return;
            }
        }

        isModifier
            ? handleWorkDialogOnCLickEvent(
                  selectedBasicComposition,
                  isAddToShopCartClicked
              )
            : handleProductOnClickEvent(
                  selectedBasicComposition,
                  isAddToShopCartClicked
              );
    };

    const handleValidateOption = () => {
        const currentItemPriceOptions =
            localStorage.getItem("currentItemPriceOptions") !== null
                ? JSON.parse(localStorage.getItem("currentItemPriceOptions"))
                : {
                      selectedOptions: [],
                      selectedOptionsUuid: [],
                      newPrice: 0,
                      tva: 0,
                      optionIndex: 0,
                      selectedIndexOptions: [],
                  };

        if (currentItemPriceOptions.selectedOptions.length > 0) {
            initialItemOrder = {
                ...initialItemOrder,
                initialPrice: currentItemPriceOptions.newPrice,
                modifier:
                    product.haveAdditionalSale === true &&
                    currentItemPriceOptions.modifier === ""
                        ? product.modifier
                        : currentItemPriceOptions.modifier,
                haveWorkflow: Boolean(currentItemPriceOptions.modifier),
                selectedOptions: currentItemPriceOptions.selectedOptions,
                selectedOptionsUuid:
                    currentItemPriceOptions.selectedOptionsUuid,
                optionIndex: currentItemPriceOptions.optionIndex,
                selectedIndexOptions:
                    currentItemPriceOptions.selectedIndexOptions,
                price: currentItemPriceOptions.newPrice,
                tva: product.price?.saleModeVatRates[selectedSaleModeId]
                    ? product.price?.saleModeVatRates[selectedSaleModeId]
                    : 0,
                urlImage: currentItemPriceOptions.optionImage,
            };
        }

        initialItemOrder.haveWorkflow ||
        (initialItemOrder.haveBasicComposition &&
            !initialItemOrder.isHiddenBasicComp) ||
        currentItemPriceOptions?.modifier !== ""
            ? handleWorkDialogOnCLickEvent(selectedBasicComposition)
            : handleProductOnClickEvent(selectedBasicComposition);
    };

    function handleProductOnClickEvent(
        selectedBasicComposition,
        isAddToShopCartClicked = false
    ) {
        if (currentWorkflow) {
            if (
                currentWorkflow.workflow[currentWorkflow.index]
                    .maxNbrOfChoices >
                    currentWorkflow.workflow[currentWorkflow.index]
                        .NbrOfChoices ||
                isAutoPermutation
            ) {
                addNbrOfChoiceStep(
                    currentWorkflow.workflow[currentWorkflow.index],
                    {
                        ...product,
                        selectedBasicComposition,
                        isAddToShopCartClicked,
                    },
                    AddWorkFlowItemShopCartData,
                    workflowData,
                    dispatch,
                    isAutoPermutation,
                    menuOnModification
                );
            } else {
                checkWorkflow(currentWorkflow, dispatch, workflowData);
            }
        } else {
            /** sous categories  et redirect item*/
            if (
                (product.type === CATEGORY_TYPE &&
                    globalcard.categories[product.iuud] !== undefined) ||
                (product.isRedirect &&
                    (product.offer === undefined || !product.offer.isEnabled))
            ) {
                dispatch(setActiveCategoryParent(product));
            } else {
                handleAddProductToShopCart();
            }
        }
    }

    const handleAllergenConfirmationDialogOnCLickEvent = () => {
        setIsAllergenConfirmationDialogOpened(
            !isAllergenConfirmationDialogOpened
        );
    };

    const handleNutritionalInformationDialogOnCloseEvent = () => {
        setIsNutritionalInformationDialogOpen(
            !isNutritionalInformationDialogOpen
        );
    };

    const handleProductSizeDialogOnCloseEvent = (_event, reason) => {
        if (reason && reason == "backdropClick") return;
        if (!initialItemOrder.isFormulaItem) {
            dispatch(setActiveSizeDialogProductId(""));
        }
        setIsProductSizeDialogOpen(false);
    };

    function handleWorkDialogOnCLickEvent(
        selectedBasicComposition = [],
        isAddToShopCartClicked = false
    ) {
        if (currentWorkflow) {
            addNbrOfChoiceStep(
                currentWorkflow.workflow[currentWorkflow.index],
                {
                    ...product,
                    selectedBasicComposition,
                    isAddToShopCartClicked,
                },
                AddWorkFlowItemShopCartData,
                workflowData,
                dispatch,
                isAutoPermutation,
                menuOnModification
            );
        } else {
            dispatch(
                SelectProduct({
                    ...initialItemOrder,
                    selectedBasicComposition,
                    isAddToShopCartClicked,
                })
            );

            dispatch(setWorkflowData([]));
            dispatch(ClearWorkflowItem());
            dispatch(setIsModification(false));
            dispatch(addToOrderworkflow(initialItemOrder));
            setSelectedBasicComposition([]);
        }
    }

    React.useEffect(() => {
        if (
            currentWorkflow !== undefined &&
            orderWorkflowItemSlice.isModification === false
        ) {
            skipStep(currentWorkflow, handleWorkDialogOnCLickEvent);
        }
    }, [currentWorkflow]);

    return (
        <React.Fragment>
            {isAdditionalSaleOpen && (
                <AdditionalSale
                    open={isAdditionalSaleOpen}
                    onClose={SetIsAdditionalSaleOpen}
                />
            )}
            {isRemoveProductConfirmationDialogOpened && (
                <RemoveProductConfirmation
                    open={isRemoveProductConfirmationDialogOpened}
                    onClose={handleRemoveProductConfirmation}
                    items={ExistOrderItems}
                    isWorkflow={
                        currentWorkflow
                            ? IS_WORKFLOW_TYPE
                            : product.isAdditionnalProduct
                            ? IS_ADDITIONAL_TYPE
                            : ""
                    }
                />
            )}

            {isAllergenConfirmationDialogOpened && (
                <AlertDialog
                    open={isAllergenConfirmationDialogOpened}
                    onClose={handleAllergenConfirmationDialogOnCLickEvent}
                    handleProductOnClickEvent={handleAddProductClick}
                    handleProductSizeDialogOnCloseEvent={
                        handleProductSizeDialogOnCloseEvent
                    }
                    product={product}
                    isModifier={isModifier}
                    handleValidateOption={handleValidateOption}
                />
            )}
            {isNutritionalInformationDialogOpen && (
                <NutritionalInformationDialog
                    open={isNutritionalInformationDialogOpen}
                    onClose={handleNutritionalInformationDialogOnCloseEvent}
                    product={{
                        ...product,
                        price: { ...product.price, content: itemPrice.price },
                    }}
                    handleProductOnClickEvent={handleAddProductClick}
                    isAllergenIconActive={isAllergenIconActive}
                    handleAllergenConfirmationDialogOnCLickEvent={
                        handleAllergenConfirmationDialogOnCLickEvent
                    }
                    isValidateButtonActive={
                        !orderWorkflowItemSlice.isModification &&
                        !orderWorkflowItemSlice.isInternalModification
                    }
                    selectedBasicComposition={selectedBasicComposition}
                    setSelectedBasicComposition={setSelectedBasicComposition}
                />
            )}
            {(isProductSizeDialogOpen || isSizeDialogOpen) && (
                <ProductSizeDialog
                    open={isProductSizeDialogOpen || isSizeDialogOpen}
                    onClose={handleProductSizeDialogOnCloseEvent}
                    product={{
                        ...product,
                        price: {
                            ...product.price,
                            content: itemPrice.price,
                        },
                    }}
                    isModifier={isModifier}
                    handleValidateOption={handleValidateOption}
                />
            )}

            <div
                style={{
                    height: "100% !important",
                    width: "100% !important",
                }}
            >
                {productType === NO_ThANKS_CARD ||
                productType === IS_NEXT_CARD ? (
                    <NoThanks
                        productType={productType}
                        product={product}
                        workflowData={workflowData}
                    />
                ) : (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                            height: "100%",
                            width: "100%",
                            borderRadius: "15px",
                            maxWidth: !isPrm
                                ? product.widthOfImage + "px"
                                : "auto",
                            minWidth: !isPrm
                                ? product.widthOfImage + "px"
                                : "auto",
                        }}
                    >
                        {product.outOfStock || product.isSuspended ? (
                            <OutOfStock
                                isOutOfStock={product.outOfStock}
                                isSuspended={product.isSuspended}
                                widthOfImage={product.widthOfImage}
                            />
                        ) : null}
                        <Card
                            key={product.iuud}
                            style={{
                                background:
                                    product.outOfStock &&
                                    orderWorkflowItemSlice.isModification &&
                                    quantity > 0
                                        ? "transparent"
                                        : (product.outOfStock ||
                                              product.isSuspended) &&
                                          "#A8A8A8 0% 0% no-repeat padding-box",
                                opacity:
                                    product.outOfStock &&
                                    orderWorkflowItemSlice.isModification &&
                                    quantity > 0
                                        ? "0.6"
                                        : (product.outOfStock ||
                                              product.isSuspended) &&
                                          "0.3",
                                borderRadius: "15px",
                                justifyContent: "space-between",
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                                width: "100%",
                            }}
                            className={`${isPrm && "pmr-grid"} ${
                                productType === BASIC_COMPOSITION &&
                                product.basicCompositionActive &&
                                "basic_compositionActive"
                            } ${
                                productType === BASIC_COMPOSITION &&
                                !product.basicCompositionActive &&
                                "basic_compositionInactive"
                            } ${
                                !isBorderCardProductActive &&
                                "border-card-product"
                            }`}
                        >
                            <ComponentRender
                                product={{
                                    ...product,
                                    price: {
                                        ...product.price,
                                        content: itemPrice.price,
                                    },
                                }}
                                productType={productType}
                                isAllergenIconActive={isAllergenIconActive}
                                setIsAllergenConfirmationDialogOpened={
                                    setIsAllergenConfirmationDialogOpened
                                }
                                handleAddProductClick={handleAddProductClick}
                                handleProductSizeDialogOnCloseEvent={
                                    handleProductSizeDialogOnCloseEvent
                                }
                                handleRemoveProductFromOrder={
                                    handleRemoveProductFromOrder
                                }
                                opacity={opacity}
                                quantity={quantity}
                                handleNutritionalInformationDialogOnCloseEvent={
                                    handleNutritionalInformationDialogOnCloseEvent
                                }
                            />
                        </Card>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export const MemoizedCardProduct = React.memo(CardProduct, areEqual);
CardProduct.propTypes = {
    product: PropTypes.object.isRequired,
    currentWorkflow: PropTypes.object,
    orderItems: PropTypes.array,
    workflowData: PropTypes.array,
    orderWorkflowItemSlice: PropTypes.object,
};
